/* Code by Ruby - convx - 530
  Filters Customily's gallery thumbnails to show only the ones tagged for the selected color (eg: alt="#color_red"),
  plus untagged/empty-alt images
*/

(function () {
  function handleize(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/, '');
  }

  function getSelectedColorHandle() {
    var fieldset = document.querySelector('fieldset[data-option-slug="color"], fieldset[data-option-slug="colour"]');
    if (!fieldset) return null;
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return null;
    return handleize(checked.value || checked.dataset.optionValue);
  }

  function filterThumbnails() {
    var colorHandle = getSelectedColorHandle();
    if (!colorHandle) return;
    var expectedTag = '#color_' + colorHandle;

    var thumbs = document.querySelectorAll('.customily_gallery_thumbnail');
    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '').trim() : '';
      var show = alt.indexOf('#') === -1 || alt.indexOf(expectedTag) !== -1;
      thumb.style.display = show ? '' : 'none';
    });
  }

  var attempts = 0;
  var waitForThumbnails = setInterval(function () {
    attempts++;
    if (document.querySelector('.customily_gallery_thumbnail')) {
      clearInterval(waitForThumbnails);
      filterThumbnails();
      return;
    }
    if (attempts >= 40) {
      clearInterval(waitForThumbnails);
    }
  }, 500);

  document.addEventListener('change', function (e) {
    if (e.target.type === 'radio') filterThumbnails();
  }, true);
})();